/**
 * @date: 2022-04-15
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */

import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import {styled, TableCell, tableCellClasses, TableContainer} from "@mui/material";
import {convertDateToTimeString} from "../utils/cert-helper";
import DownloadIcon from '@mui/icons-material/Download';
import {ApiUrl} from "../utils/portal-urls";
import CancelIcon from '@mui/icons-material/Cancel';

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function BinaryDialog(props) {
    const { binaryDialogOpen, setBinaryDialogOpen, binaries } = props;

    const handleClose = () => {
        setBinaryDialogOpen(false);
    };

    return (
        <div>
            {binaries?.length > 0 &&
                <Dialog
                    open={binaryDialogOpen}
                    onClose={handleClose}
                    aria-labelledby="dialog-title"
                    aria-describedby="dialog-description"
                    maxWidth='lg'
                >
                    <DialogTitle id="dialog-title">
                        Binaries
                    </DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650, m: 0}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>HISP</StyledTableCell>
                                        <StyledTableCell>Name</StyledTableCell>
                                        <StyledTableCell>Type</StyledTableCell>
                                        <StyledTableCell>Created Time</StyledTableCell>
                                        <StyledTableCell>Report</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {binaries.map( binary => (
                                        <StyledTableRow
                                            key={binary.id}
                                        >
                                            <StyledTableCell component="th" scope="row">
                                                {binary.hispId}
                                            </StyledTableCell>
                                            <StyledTableCell>{binary.name}</StyledTableCell>
                                            <StyledTableCell>{binary.type}</StyledTableCell>
                                            <StyledTableCell>{convertDateToTimeString(binary.createdTs)}</StyledTableCell>
                                            <StyledTableCell>
                                                <Button href={ApiUrl.Contributions.getBinaryReport.getPath(binary.id)}
                                                        target='_blank'
                                                        startIcon={<DownloadIcon />}
                                                        size='small'
                                                >download</Button>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions sx={{ display: 'flex', justifyContent: 'center', pt: 0}}>
                        <Button onClick={handleClose} autoFocus variant='contained' sx={{ marginRight: '24px'}}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </div>
    );
}
